// @ts-nocheck

//////////////////////////////////////
//   This file is auto generated   //
//////////////////////////////////////


export type eStatusStatus = "Internal" | "inquiry" | "request" | "conditionally" | "approved" | "WithCertificate" | "WithoutCertificate" | "absent" | "rejected" | "canceled"
export const eStatusStatus_AllValues = ["Internal", "inquiry", "request", "conditionally", "approved", "WithCertificate", "WithoutCertificate", "absent", "rejected", "canceled"] as const
export const defaulteStatusStatus: eStatusStatus = "Internal"

export type SignatureType = "Internal" | "External"
export const SignatureType_AllValues = ["Internal", "External"] as const
export const defaultSignatureType: SignatureType = "Internal"

export type IdentificationMethod = "DocuSign_EU_ID_QES"
export const IdentificationMethod_AllValues = ["DocuSign_EU_ID_QES"] as const
export const defaultIdentificationMethod: IdentificationMethod = "DocuSign_EU_ID_QES"

export type ts_AuffStatus = "request" | "optional" | "unconfirmed" | "normal" | "fixed" | "canceledExtern" | "canceledrequest" | "canceled"
export const ts_AuffStatus_AllValues = ["request", "optional", "unconfirmed", "normal", "fixed", "canceledExtern", "canceledrequest", "canceled"] as const
export const defaultts_AuffStatus: ts_AuffStatus = "request"

export type UserType = "User" | "WebUser" | "ExternalServiceUser" | "ServiceUser" | "DatabaseRole" | "UserGroup"
export const UserType_AllValues = ["User", "WebUser", "ExternalServiceUser", "ServiceUser", "DatabaseRole", "UserGroup"] as const
export const defaultUserType: UserType = "User"

export type MfaType = "None" | "Optional" | "Required"
export const MfaType_AllValues = ["None", "Optional", "Required"] as const
export const defaultMfaType: MfaType = "None"

export type ChatMemberType = "BroadcastMember" | "Member" | "Admin"
export const ChatMemberType_AllValues = ["BroadcastMember", "Member", "Admin"] as const
export const defaultChatMemberType: ChatMemberType = "BroadcastMember"

export type ChatType = "Direct" | "PrivateGroup" | "Broadcast" | "PublicGroup" | "Feed" | "BroadcastFeed"
export const ChatType_AllValues = ["Direct", "PrivateGroup", "Broadcast", "PublicGroup", "Feed", "BroadcastFeed"] as const
export const defaultChatType: ChatType = "Direct"

export type AuthenticationFactorType = "AuthenticatorApp" | "Email"
export const AuthenticationFactorType_AllValues = ["AuthenticatorApp", "Email"] as const
export const defaultAuthenticationFactorType: AuthenticationFactorType = "AuthenticatorApp"

export type WorkingTimeImportStatus = "New" | "Edited" | "Revised" | "Requested" | "Approved" | "Rejected" | "Finished" | "Failed" | "Deleted" | "FinishedWithTimeRuleValidationError" | "Cancelled" | "FinishedAfterRevised"
export const WorkingTimeImportStatus_AllValues = ["New", "Edited", "Revised", "Requested", "Approved", "Rejected", "Finished", "Failed", "Deleted", "FinishedWithTimeRuleValidationError", "Cancelled", "FinishedAfterRevised"] as const
export const defaultWorkingTimeImportStatus: WorkingTimeImportStatus = "New"

export type WorkingTimeBookingError = "Duplicate" | "Length" | "Reason" | "PairingFailed"
export const WorkingTimeBookingError_AllValues = ["Duplicate", "Length", "Reason", "PairingFailed"] as const
export const defaultWorkingTimeBookingError: WorkingTimeBookingError = "Duplicate"

export type Permission = "ReadOnly" | "ReadAndWrite" | "NotAllowed"
export const Permission_AllValues = ["ReadOnly", "ReadAndWrite", "NotAllowed"] as const
export const defaultPermission: Permission = "ReadOnly"

export type DutyTimeReason = "DepartureTime" | "MaskTime" | "PresenceStartTime" | "CleanUpEnd" | "PresenceEndTime" | "ArrivalTime" | "Task"
export const DutyTimeReason_AllValues = ["DepartureTime", "MaskTime", "PresenceStartTime", "CleanUpEnd", "PresenceEndTime", "ArrivalTime", "Task"] as const
export const defaultDutyTimeReason: DutyTimeReason = "DepartureTime"


